module.exports = __webpack_public_path__ + "img/print-table-icon.0224c159.svg";